import React, { useState } from "react";
import { Row, Col, Form, Button, Spinner, Alert } from "react-bootstrap";
import { FiUpload } from "react-icons/fi";
import { useOutletContext } from "react-router-dom";
import Header from "../components/Header";
import { getHost } from "../utils/utils";

const getToken = () => localStorage.getItem("jwt");

const ProxyManagement = () => {
  const { toggleSidebar } = useOutletContext();
  const [filename, setFilename] = useState("dcs.txt");
  const [content, setContent] = useState("");
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState("");

  const proxyCount = content
    .split("\n")
    .filter((line) => line.trim()).length;

  const handleSubmit = async () => {
    setSaving(true);
    setMessage("");

    try {
      const res = await fetch(`${getHost()}/api/proxies/upload`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${getToken()}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ filename, content }),
      });

      const data = await res.json();
      if (!res.ok) throw new Error(data.error);

      setMessage("Proxy upload command sent successfully!");
      setContent("");
      setFilename("dcs.txt");
    } catch (error) {
      setMessage(`Failed: ${error.message}`);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="w-100 monitor-setting">
      <Header toggleSidebar={toggleSidebar} />
      <div className="pb-4 mx-4 content-body">
        <Row className="gx-0 align-items-center">
          <Col md={12}>
            <div className="mb-2">
              <div className="d-inline-flex align-items-center justify-content-center bg-dark rounded p-2 mb-2">
                <FiUpload className="text-white" />
              </div>
              <h4 className="fs-22 text-main mb-1">Upload Proxies</h4>
              <p className="text-white-65 fs-14 mb-0">
                Replace shared proxy file contents
              </p>
            </div>
          </Col>
        </Row>
      </div>

      <div className="px-4 mb-4">
        <Row>
          <Col md={6}>
            {message && (
              <Alert
                variant={message.startsWith("Failed") ? "danger" : "success"}
                dismissible
                onClose={() => setMessage("")}
                className="mb-3"
              >
                {message}
              </Alert>
            )}

            <Form.Group className="mb-3">
              <Form.Label className="text-main">Proxy File</Form.Label>
              <Form.Select
                value={filename}
                onChange={(e) => setFilename(e.target.value)}
                className="form-input-field rounded-3 text-main custom-select-white"
              >
                <option value="dcs.txt">dcs.txt</option>
                <option value="resis.txt">resis.txt</option>
              </Form.Select>
            </Form.Group>

            <Form.Group className="mb-2">
              <Form.Label className="text-main">Proxies</Form.Label>
              <Form.Control
                as="textarea"
                rows={10}
                value={content}
                onChange={(e) => setContent(e.target.value)}
                placeholder={"host:port:user:password\nhost:port:user:password\n..."}
                className="form-input-field"
              />
            </Form.Group>
            <div className="text-white-65 fs-12 mb-3">
              {proxyCount} {proxyCount === 1 ? "proxy" : "proxies"}
            </div>

            <Button
              variant="primary"
              onClick={handleSubmit}
              disabled={saving || !content.trim()}
              className="rounded-3 py-2 px-4 fw-600 fs-14 d-flex align-items-center gap-2"
            >
              {saving ? <Spinner size="sm" /> : <FiUpload />}
              Upload
            </Button>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default ProxyManagement;
